<template>
    <v-dialog
        v-model="showDialog"
        width="1200"
    >
        <v-card>
            <v-card-title
                style="background-color: #009688; color: white;"
            >
                Package Name: &nbsp;<v-chip>{{ data && data.DIA_T ? data.DIA_T : '' }}</v-chip>
                <v-spacer />
                <v-btn color="success" width="100" @click="addDiagnosticFunc">
                    <v-icon small>
                        {{ mdiPlus }}
                    </v-icon>new
                </v-btn>&nbsp;
                <v-btn color="error" width="100" @click="showDialog = false">
                    <v-icon small>
                        {{ mdiClose }}
                    </v-icon>close
                </v-btn>
            </v-card-title>
            <v-data-table
                class="acuPackageTbl"
                :items="items"
                :headers="headers"
                :items-per-page="-1"
            >
                <template #item="{ item, index }">
                    <tr
                        @mouseenter="hoveredRow = index"
                        @mouseleave="hoveredRow = null"
                    >
                        <td
                            v-for="header in headers"
                            :key="header.value"
                            :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', textAlign: ['ACTIONS'].includes(header.value) ? 'center' : '' }"
                        >
                            <span style="text-wrap: nowrap;">
                                <template v-if="header.value === 'MODIFIED_DATE'">
                                    {{ formatDate(item.MODIFIED_DATE) }}
                                </template>
                                <template v-else-if="header.value === 'ACTIONS'">
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="primary"
                                                v-on="on"
                                                @click="showHistory(item)"
                                            >
                                                <v-icon>{{ mdiEye }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Show History</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="warning"
                                                v-on="on"
                                                @click="editDiagnosticFunc(item)"
                                            >
                                                <v-icon>{{ mdiPencil }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit Diagnostic</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="error"
                                                v-on="on"
                                                @click="deleteDiagnosticFunc(item)"
                                            >
                                                <v-icon>{{ mdiTrashCan }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete Diagnostic</span>
                                    </v-tooltip>
                                </template>
                                <template v-else>
                                    {{ item[header.value] }}
                                </template>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <ShowHistory
            :show="history.show"
            :data="history.data"
            @closeDialog="history.show = false"
        />
        <UpdateDiagnostic
            :show="editDiagnostic.show"
            :data="editDiagnostic.data"
            :notif="notif"
            @closeDialog="editDiagnostic.show = false"
        />
        <DeleteDiagnostic
            :show="deleteDiagnostic.show"
            :data="deleteDiagnostic.data"
            :notif="notif"
            @closeDialog="deleteDiagnostic.show = false"
        />
        <NewDiagnostic
            :show="addDiagnostic.show"
            :data="addDiagnostic.data"
            :notif="notif"
            @closeDialog="addDiagnostic.show = false"
        />
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NewDiagnostic from './NewDiagnostic.vue'
import DeleteDiagnostic from './DeleteDiagnostic.vue'
import UpdateDiagnostic from './UpdateDiagnostic.vue'
import ShowHistory from './ShowHistory.vue'
import {
    mdiPlus,
    mdiClose,
    mdiEye,
    mdiPencil,
    mdiTrashCan
} from '@mdi/js'
import { moment } from '../../../../../../utils/date-shim'

export default {
    components: { ShowHistory, UpdateDiagnostic, DeleteDiagnostic, NewDiagnostic },
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiPlus,
        mdiClose,
        mdiEye,
        mdiPencil,
        mdiTrashCan,
        hoveredRow: null,
        items: [],
        headers: [
            { text: 'Diagnostics', value: 'DIA_T' },
            // { text: 'MSU_TYPE', value: 'MSU_TYPE' },
            { text: 'Modified By', value: 'MODIFIED_BY' },
            { text: 'Modified Date', value: 'MODIFIED_DATE' },
            { text: 'Actions', value: 'ACTIONS', align: 'center' }
        ],
        history: {
            show: false,
            data: null
        },
        editDiagnostic: {
            show: false,
            data: null
        },
        deleteDiagnostic: {
            show: false,
            data: null
        },
        addDiagnostic: {
            show: false,
            data: null
        }
    }),
    computed: {
        ...mapGetters(['getPackageDiagnosticsData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        getPackageDiagnosticsData(newVal) {
            if (newVal.status === 200) {
                this.items = newVal.data.sort((a, b) => a.DIA_T - b.DIA_T)
            }
        },
        show(newVal) {
            if (newVal) {
                this.getPackageDiagnostics({ RATE_ID: this.data.ID })
            }
        }
    },
    methods: {
        ...mapActions(['getPackageDiagnostics']),
        addDiagnosticFunc() {
            this.addDiagnostic = { show: true, data: this.data }
        },
        deleteDiagnosticFunc(data) {
            this.deleteDiagnostic = { show: true, data }
        },
        editDiagnosticFunc(data) {
            this.editDiagnostic = { show: true, data }
        },
        showHistory(data) {
            this.history = { show: true, data }
        },
        formatDate(date) {
            return moment(date).utcOffset('+0800').format('MMMM DD, YYYY hh:mm A')
        }
    }
}
</script>

<style>
.acuPackageTbl > div > table > thead > tr > th {
    width: 100px; /* You can adjust this width as needed */
    position: sticky !important;
    z-index: 2; /* Ensure the second column has a lower z-index than the first one */
    background: white;
    top: 0;
}
.acuPackageTbl > div > table > tbody > tr > td:last-child {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    right: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: white;
}
.acuPackageTbl > div > table > thead > tr > th:last-child {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    top: 0;
    right: 0;
    z-index: 5; /* Ensure the first column has a higher z-index */
    background: white;
}
.acuPackageTbl .v-data-table__wrapper {
    max-height: 70vh; /* Adjust the height according to your needs */
    overflow-y: auto; /* Enable vertical scrolling */
}
</style>
